import React, { Fragment } from "react";
import Highlight from "../Highlight";
import SimpleBox from "../SimpleBox";
import BalanceChart from "../BalanceChart";
import WhatIsModal from "../WhatIsModal";
import stringReplace from "react-string-replace";
import getResultsText from "../../helpers/getResultsText";
import s from "./style.module.css";

const ResultsBox = ({ metrics, words, copy, isLoading }) => {
  const {
    male_coded_count,
    female_coded_count,
    male_per_100_score,
  } = metrics || {
    male_coded_count: 0,
    female_coded_count: 0,
    male_per_100_score: 0,
    female_per_100_score: 0,
  };

  const total = male_coded_count + female_coded_count;

  const resultsText = getResultsText(
    copy.results,
    male_coded_count,
    female_coded_count
  );

  const getBiasTitle = (title, percentageMale) => {
    const replacements = { percentageMale };

    return Object.entries(replacements).reduce((string, [key, value]) => {
      return stringReplace(string, `{{${key}}}`, (match) => (
        <strong>{value}</strong>
      ));
    }, title);
  };

  return (
    <SimpleBox title={copy.title} extra={<WhatIsModal />} isLoading={isLoading}>
      <div className={s.wrap}>
        <p className={s.resultsTitle}>{resultsText}</p>

        {total !== 0 && (
          <>
            <div className={s.chart}>
              <BalanceChart {...metrics} />
            </div>
            <p className={s.title}>
              {copy.results.bias[metrics.amount_of_bias]}{" "}
              {getBiasTitle(copy.wordsListTitle, male_per_100_score.toFixed(1))}
              {male_per_100_score > 0 && <> {copy.replacementText}</>}
            </p>

            <p className={s.words}>
              {words
                .filter(({ coding }) => coding === "male-coded")
                .sort((a, b) => a.term.localeCompare(b.term))
                .map(({ term, coding }, i) => (
                  <Fragment key={i}>
                    <Highlight type={coding}>{term}</Highlight>{" "}
                  </Fragment>
                ))}
            </p>
          </>
        )}
      </div>
    </SimpleBox>
  );
};

export default ResultsBox;
